export class DrawOrderData {
    constructor() {
        this.drawOrder = [];
    }
}
